const typography = {
  fontFamily: ['SF ui Display', 'Helvetica', 'Arial', 'sans-serif'].join(', '),
};

export default typography;
